var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbox"},_vm._l((_vm.topList),function(item,index){return _c('div',{key:index,staticClass:"levelList_i",class:_vm.tabActive == item.path ? 'act' : '',on:{"click":function($event){$event.preventDefault();return _vm.handleLink(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }